/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_STATUS = "APPROVED" | "NONE" | "PREMOD" | "REJECTED" | "SYSTEM_WITHHELD" | "%future added value";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type RejectedTombstoneContainer_comment = {
    readonly status: COMMENT_STATUS;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly " $refType": "RejectedTombstoneContainer_comment";
};
export type RejectedTombstoneContainer_comment$data = RejectedTombstoneContainer_comment;
export type RejectedTombstoneContainer_comment$key = {
    readonly " $data"?: RejectedTombstoneContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"RejectedTombstoneContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RejectedTombstoneContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastViewerAction",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '95bc78a9ee4caf5008bc45b3e40875af';
export default node;
